import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import { APIRoutes } from "../../../utility/app-routes";
import { MasterCommonRecordPage } from "../../../components/common/common-master-record/master-common-record-page";

const PropertyStatus: React.FC = () => {
	// Table Pagination

	return (
		<div className="page-inner">
			<>
				<MasterCommonRecordPage
					addUpdateApiUrl={APIRoutes.appUpdatePropertyStatus}
					deleteApiUrl={APIRoutes.deletePropertyStatus}
					title="Property Status"
					getAllRecordApiUrl={APIRoutes.getAllPropertyStatus}
				/>
			</>
		</div>
	);
};
export default PropertyStatus;
